import { render, staticRenderFns } from "./AdditionalForm.vue?vue&type=template&id=02394ff9&scoped=true"
import script from "./AdditionalForm.vue?vue&type=script&lang=js"
export * from "./AdditionalForm.vue?vue&type=script&lang=js"
import style0 from "./AdditionalForm.vue?vue&type=style&index=0&id=02394ff9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02394ff9",
  null
  
)

export default component.exports